import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronDown } from "@fortawesome/free-solid-svg-icons";

import GanttRowLabel from "./GanttRowLabel";
import GanttBar from "./GanttBar";
import GanttMilestone from "./GanttMilestone";

export default function GanttRow(props) {

  var {
    type,
    label,
    status,
    expanded,
    onToggle,
    onClick,

    plannedStart,
    plannedEnd,
    actualStart,
    actualEnd,

    timelineStart,
    weekWidth,
    rowHeight,
    ganttMode
  } = props;

  var isProject = type === "project";
  var isActive = isProject && expanded;

  return (
    <div style={{ ...styles.row, height: rowHeight }}>

      {/* LEFT: LABEL PANEL */}
      <div style={styles.labelColumn}>
        <div
          style={{
            ...styles.labelRow,
            ...(isActive ? styles.labelRowActive : {})
          }}
          onClick={isProject ? onToggle : undefined}
        >

          <div style={styles.leftContent}>
            {isProject && (
              <FontAwesomeIcon
                icon={expanded ? faChevronDown : faChevronRight}
                style={styles.chevron}
              />
            )}

            <GanttRowLabel
              type={type}
              label={label}
              status={status}
              expanded={expanded}
              onToggle={onToggle}
              onClick={onClick}
            />
          </div>
        </div>
      </div>

      {/* RIGHT: TIMELINE */}
      <div
        style={{
          ...styles.timelineColumn,
          ...(isActive ? styles.timelineColumnActive : {})
        }}
      >
        <div style={styles.timelineInner}>

          <GanttBar
            plannedStart={plannedStart}
            plannedEnd={plannedEnd}
            actualStart={actualStart}
            actualEnd={actualEnd}
            timelineStart={timelineStart}
            weekWidth={weekWidth}
            rowHeight={rowHeight}
            status={status}
            label={label}
            ganttMode={ganttMode}
          />

          {isProject && (
            <>
              <GanttMilestone
                date={new Date("2025-02-01")}
                timelineStart={timelineStart}
                weekWidth={weekWidth}
                rowHeight={rowHeight}
                colour="#1565c0"
                title="Project Approved"
              />

              <GanttMilestone
                date={new Date("2025-06-01")}
                timelineStart={timelineStart}
                weekWidth={weekWidth}
                rowHeight={rowHeight}
                colour="#2e7d32"
                title="Target Completion"
              />
            </>
          )}

        </div>
      </div>

    </div>
  );
}

/* ================= STYLES ================= */

const styles = {

  row: {
    display: "flex",
    width: "100%",
    minHeight: "60px"
  },

  /* ----- LEFT COLUMN ----- */
  labelColumn: {
	display:'flex',
    width: "320px",
    padding: "10px 0 10px 10px",
    background: "transparent",
  },

  labelRow: {
	width:"100%",
    height: "40px",
    display: "flex",
    alignItems: "center",

    background: "linear-gradient(180deg, #2f343c 0%, #1f2329 100%)",

    borderTopLeftRadius: "14px",
    borderBottomLeftRadius: "14px",

    borderRight: "1px solid rgba(255,255,255,0.08)",
    borderBottom: "1px solid rgba(255,255,255,0.06)",

    boxShadow: "0 6px 14px rgba(0,0,0,0.35)",

    padding: "0 12px",
    cursor: "pointer"
  },

  labelRowActive: {
    background: "linear-gradient(180deg, #4285F4 0%, #1E58B6 100%)",
    boxShadow: "0 8px 18px rgba(30,88,182,0.45)"
  },

  leftContent: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    overflow: "hidden",
	width:"100%",
	flex:"1"
  },

  chevron: {
    fontSize: "14px",
    color: "rgba(255,255,255,0.85)"
  },

  /* ----- TIMELINE ----- */
  timelineColumn: {
    flex: 1,
    position: "relative",
    background: "linear-gradient(180deg, #f2f5fa 0%, #edf1f7 100%)",
    borderBottom: "1px solid rgba(0,0,0,0.06)",
    paddingLeft: "4px"
  },

  timelineColumnActive: {
    margin: "10px 10px 10px 0",
    background: "linear-gradient(180deg, #E9F1FF 0%, #D6E6FF 100%)",
    borderTopRightRadius: "14px",
    borderBottomRightRadius: "14px",
    boxShadow: "0 6px 16px rgba(30,88,182,0.25)"
  },

  timelineInner: {
    position: "relative",
    height: "100%"
  }
};
